<template>
  <div class="flex flex-col xs:flex-row xs:items-center">
    <span class="mb-4 font-medium xs:mb-0 xs:mr-8">
      {{ $t('share_article') }}
    </span>

    <ul class="flex items-center space-x-2 text-blue-800">
      <li>
        <a
          :href="mailtoUrl"
          target="_blank"
          class="inline-block h-10 w-10 rounded-[0.25rem] bg-blue-100/20 p-3 transition hover:bg-blue-100/50 xs:h-12 xs:w-12 xs:p-3.5"
          :aria-label="$t('accessibility.send_page_url_as_mail')"
        >
          <MailIcon class="h-full w-full" />
        </a>
      </li>
      <li>
        <a
          :href="facebookUrl"
          target="_blank"
          class="inline-block h-10 w-10 rounded-[0.25rem] bg-blue-100/20 p-3 transition hover:bg-blue-100/50 xs:h-12 xs:w-12 xs:p-3.5"
          :aria-label="$t('accessibility.share_page_on_facebook')"
        >
          <FacebookIcon class="h-full w-full" />
        </a>
      </li>
      <li>
        <a
          :href="twitterUrl"
          target="_blank"
          class="inline-block h-10 w-10 rounded-[0.25rem] bg-blue-100/20 p-3 transition hover:bg-blue-100/50 xs:h-12 xs:w-12 xs:p-3.5"
          :aria-label="$t('accessibility.share_page_on_twitter')"
        >
          <TwitterIcon class="h-full w-full" />
        </a>
      </li>
      <li>
        <a
          :href="linkedinUrl"
          target="_blank"
          class="inline-block h-10 w-10 rounded-[0.25rem] bg-blue-100/20 p-3 transition hover:bg-blue-100/50 xs:h-12 xs:w-12 xs:p-3.5"
          :aria-label="$t('accessibility.share_page_on_linkedin')"
        >
          <LinkedinIcon class="h-full w-full" />
        </a>
      </li>
      <li>
        <a
          :href="whatsappUrl"
          target="_blank"
          class="inline-block h-10 w-10 rounded-[0.25rem] bg-blue-100/20 p-3 transition hover:bg-blue-100/50 xs:h-12 xs:w-12 xs:p-3.5"
          :aria-label="$t('accessibility.share_page_on_whatsapp')"
        >
          <WhatsappIcon class="h-full w-full" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
const props = defineProps({
  alternates: {
    type: Array,
    default: () => [],
  },
})

const { locale } = useI18n()

const sharableLinkOfCurrentLocale = computed(() => {
  const currentLocale = locale.value
  const currentLocaleAlternate = props.alternates.find(
    (alternate) => alternate.locale === currentLocale
  )

  return currentLocaleAlternate?.permalink
})

const mailtoUrl = computed(() => {
  return `mailto:?body=${sharableLinkOfCurrentLocale.value}`
})

const facebookUrl = computed(() => {
  return `https://www.facebook.com/sharer/sharer.php?u=${sharableLinkOfCurrentLocale.value}`
})

const twitterUrl = computed(() => {
  return `https://twitter.com/intent/tweet?url=${sharableLinkOfCurrentLocale.value}`
})

const linkedinUrl = computed(() => {
  return `https://www.linkedin.com/shareArticle?mini=true&url=${sharableLinkOfCurrentLocale.value}`
})

const whatsappUrl = computed(() => {
  return `https://api.whatsapp.com/send?text=${sharableLinkOfCurrentLocale.value}`
})
</script>
